import { style } from 'typestyle'
export const h100 = style({ height: '100%' })
